var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 253,
    viewBox: "0 0 383 253",
    width: 383,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h383v253h-383z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 40,
    rx: 20,
    width: 40,
    x: 37,
    y: 142.973
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 40,
    rx: 20,
    transform: "matrix(-1 0 0 1 77 80.6045)",
    width: 40
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 40,
    rx: 20,
    width: 40,
    x: 37,
    y: 200.94
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-12.688 14.3848c0-3.3137 2.6863-6.00003 6.00001-6.00003h383.68799c3.314 0 6 2.68633 6 6.00003v234.0222c0 3.314-2.686 6-6 6h-383.688c-3.3137 0-6-2.686-6-6z",
    fill: "#e8e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.3999 71.634h378.4971v240.022c0 3.314-2.686 6-6 6h-366.4971c-3.3137 0-6-2.686-6-6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#dadaff",
    height: 40,
    rx: 20,
    width: 40,
    x: 37,
    y: 142.973
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.3999 195.103 7.2-19.27c1.8656-4.555 6.3973-7.53 11.2063-7.53h2.7909 16.8029c6.6273 0 12.7999 5.373 12.7999 12v14.8z",
    fill: "#413d99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.3602 159.884c-1.4775-1.113-2.7476-2.011-3.5662-3.314-.8168-1.306-1.1782-3.015-.8563-4.688.322-1.674 1.3253-3.306 2.7546-4.006 1.4325-.702 3.2866-.472 5.3531-.447 2.0658.025 4.3433-.154 5.264.873.9175 1.029.4825 3.269.2512 5.221-.2354 1.951-.2621 3.619-.9566 5.256-.6935 1.642-2.0464 3.255-3.5663 3.399-1.5165.143-3.2012-1.184-4.6775-2.294z",
    fill: "#43260e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.7044 159.769v2.812c0 1.676-1.0299 3.111-2.4912 3.707v3.096c0 1.99-1.6126 3.602-3.602 3.602-1.9893 0-3.602-1.612-3.602-3.602v-3.174c-1.3653-.637-2.3115-2.023-2.3115-3.629v-2.812c-.9004-.1-1.6008-.863-1.6008-1.79s.7004-1.69 1.6008-1.79v-.011h.8004l.8005-4.803h8.8049l.8004 4.803h.8005v.011c.9005.099 1.601.863 1.601 1.79s-.7005 1.69-1.601 1.79z",
    fill: "#c18959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.6989 163.382 3.2017-1.601c.4637.386 1.1372.386 1.6009 0l3.2018 1.601c.6631 0 1.2007-.538 1.2007-1.201v-2.401c0-.442.3583-.801.8004-.801v4.002c0 3.095-2.5086 5.604-5.6031 5.604h-.8004c-3.0945 0-5.6031-2.509-5.6031-5.604v-4.002c.442 0 .8004.359.8004.801v2.401c0 .663.5376 1.201 1.2007 1.201z",
    fill: "#43260e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.3409 157.378c-.221 0-.4002.239-.4002.534s.1792.534.4002.534",
    stroke: "#c18959",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.1481 157.378c.2211 0 .4002.239.4002.534s-.1791.534-.4002.534",
    stroke: "#c18959",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#43260e"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.0765,
    cy: 157.378,
    rx: 0.400223,
    ry: 0.400222
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.1458,
    cy: 157.379,
    rx: 0.400223,
    ry: 0.400222
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#dadaff",
    height: 40,
    rx: 20,
    transform: "matrix(-1 0 0 1 77 80.6045)",
    width: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.0668 85.512c2.7334 0 4.5562.4135 5.9227 2.0678 2.5356-.0369 3.344 3.2125 3.344 5.2434 0 8.5248-6.9104 15.4348-15.4348 15.4348h-8.4118s.4556-3.722 3.1893-6.203c2.7338-2.4819 3.6447-3.7226 3.6447-8.6853 0-6.2035 5.0124-7.8577 7.7459-7.8577z",
    fill: "#a95b29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.5999 133.005h-43.2l8.4205-20.408c1.7111-4.179 5.7715-6.907 10.2783-6.907h12.8324c6.4837 0 11.7398 5.256 11.7398 11.74z",
    fill: "#413d99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.5249 94.9747-.5984-4.3702-3.1164 2.1303c-1.2989.8878-2.8872 1.2026-4.4034.8979-.2391-.1451-.5192-.2286-.8187-.2286-.8771 0-1.5882.7163-1.5882 1.6 0 .8836.711 1.5999 1.5882 1.5999v9.201c0 1.325 1.0667 2.399 2.3824 2.399 1.3158 0 2.3825-1.074 2.3825-2.399v-3.601h.1917c2.6276 0 4.6499-2.3389 4.2907-4.9625l-.0482-.352.5068-.0794c.2744-.0431.3998-.3693.2259-.5875z",
    fill: "#f9d8b8"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43260e",
    r: 0.4,
    transform: "matrix(-1 0 0 1 63.8 93.8045)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ffb178",
    rx: 1.6,
    ry: 1.6,
    transform: "matrix(-1 0 0 1 62.1998 96.2045)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.6025 96.6045h-4.4024v15.3415c2.4314 0 4.4024-1.971 4.4024-4.402z",
    fill: "#a95b29"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m306.7 23.334h-8.571c-.947 0-1.714.6716-1.714 1.5v1c0 .8284.767 1.5 1.714 1.5h8.571c.634 0 1.187-.3009 1.484-.7483.008-.0121.016-.0244.024-.0367.132-.2126.207-.4561.207-.715v-1c0-.8284-.768-1.5-1.715-1.5z",
    fill: "#6861f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.415 25.334h-3.5v.5c0 1.8387-1.634 3-3.215 3h-8.571c-1.581 0-3.214-1.1613-3.214-3v-.5h-3.5c-1.105 0-2 .8954-2 2v26c0 1.1046.895 2 2 2h22c1.104 0 2-.8954 2-2v-26c0-1.1046-.896-2-2-2z",
    fill: "#6861f2"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m296.536 42.6162 3.653 3.6048s5.374-6.5188 9.806-9.4247",
    stroke: "#fff",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188 39.334c0 8.8365-7.163 16-16 16s-16-7.1635-16-16c0-8.8366 7.163-16 16-16s16 7.1634 16 16z",
    stroke: "#6861f2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.561 34.3c-.379-1.2137-2.081-2.4899-4.391-2.4899-2.916 0-4.731 1.4253-4.731 3.5908 0 1.4437 1.52 2.6864 4.561 3.7283 3.04 1.042 4.561 2.2847 4.561 3.7284 0 2.1654-1.815 3.5908-4.731 3.5908-2.31 0-4.012-1.2762-4.391-2.49m4.688-14.5888v2.374m0 14.6998v2.8547",
    stroke: "#6861f2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.49 126.57h274.067",
    stroke: "#e9e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.49 190.57h274.067",
    stroke: "#e9e9ed"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#e9e9ed",
    height: 40,
    rx: 20,
    width: 40,
    x: 37,
    y: 200.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.6189 207.499c4.2835 5.518 1.0878 14.724 3.2047 16.953 3.7428 3.94 2.5888 8.63 2.5888 8.63h-19.9725s-2.8968-1.93-2.8968-6.979c0-5.07 1.3372-7.765 1.3372-11.314 0-6.278 3.4654-10.237 5.9048-10.808 1.5655-.366 4.1165-.475 5.1837.856 0 0 2.4844-.127 4.6501 2.662z",
    fill: "#51516c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3999 255.66 7.7669-20.787c2.0125-4.914 6.901-8.123 12.0887-8.123h3.0107 18.1259c7.1492 0 13.8078 5.796 13.8078 12.945v15.965z",
    fill: "#7d7d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.1831 232.36c0 2.43-1.9702 4.4-4.4005 4.4v-17.486h4.4005z",
    fill: "#51516c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.3714 217.536v3.033c0 1.806-1.0006 3.354-2.5761 3.996v3.339c0 2.144-1.6418 3.883-3.8962 3.883-2.1448 0-3.8835-1.739-3.8835-3.883v-3.423c-1.472-.687-2.589-2.181-2.589-3.912v-3.033c-.9708-.107-1.7259-.93-1.7259-1.93 0-.999.7551-1.822 1.7259-1.929v-.013h.8629c0-2.859 2.3184-5.178 5.1781-5.178h4.218l1.8228 5.178h.863v.013c.9709.107 1.7261.93 1.7261 1.929 0 1-.7552 1.823-1.7261 1.93z",
    fill: "#d4d4da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.1476 214.965c-.2385 0-.4318.258-.4318.576 0 .317.1933.575.4318.575",
    stroke: "#d4d4da",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.963 214.965c.2385 0 .4318.258.4318.576 0 .317-.1933.575-.4318.575",
    stroke: "#d4d4da",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#51516c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.5842 221 3.452-1.726c.4999.416 1.2261.416 1.726 0l3.452 1.726c.7149 0 1.2944-.58 1.2944-1.295v-6.472h.863v7.335c0 3.337-2.7046 6.041-6.0409 6.041h-.863c-3.3363 0-6.0409-2.704-6.0409-6.041v-7.335h.8629v6.472c0 .715.5796 1.295 1.2945 1.295z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.1766,
    cy: 214.965,
    r: 0.431736
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.6454,
    cy: 214.966,
    rx: 0.431736,
    ry: 0.431736
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m183.085 92.5905c.52.5207.52 1.3649 0 1.8856l-14.142 14.1419c-.25.25-.59.391-.943.391-.354 0-.693-.141-.943-.391l-5.313-5.313c-.521-.521-.521-1.365 0-1.886.52-.52 1.365-.52 1.885 0l4.371 4.371 13.199-13.1995c.521-.5207 1.365-.5207 1.886 0z",
    fill: "#51c466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.085 92.5905c.52.5207.52 1.3649 0 1.8856l-14.142 14.1419c-.25.25-.59.391-.943.391-.354 0-.693-.141-.943-.391l-5.313-5.313c-.521-.521-.521-1.365 0-1.886.52-.52 1.365-.52 1.885 0l4.371 4.371 13.199-13.1995c.521-.5207 1.365-.5207 1.886 0z",
    fill: "#51c466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.085 155.984c.52.521.52 1.365 0 1.886l-14.142 14.142c-.25.25-.59.39-.943.39-.354 0-.693-.14-.943-.39l-5.313-5.313c-.521-.521-.521-1.365 0-1.886.52-.521 1.365-.521 1.885 0l4.371 4.37 13.199-13.199c.521-.521 1.365-.521 1.886 0z",
    fill: "#51c466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.748 223.94c.552 0 1 .448 1 1s-.448 1-1 1c-13.728 0-2.939 0-16.667 0-.552 0-1-.448-1-1s.448-1 1-1z",
    fill: "#c4c2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.085 155.669c.52.52.52 1.365 0 1.885l-14.142 14.142c-.25.25-.59.391-.943.391-.354 0-.693-.141-.943-.391l-5.313-5.313c-.521-.521-.521-1.365 0-1.885.52-.521 1.365-.521 1.885 0l4.371 4.37 13.199-13.199c.521-.521 1.365-.521 1.886 0z",
    fill: "#51c466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.085 217.588c.52.521.52 1.365 0 1.886l-14.142 14.142c-.25.25-.59.39-.943.39-.354 0-.693-.14-.943-.39l-5.313-5.313c-.521-.521-.521-1.365 0-1.886.52-.521 1.365-.521 1.885 0l4.371 4.37 13.199-13.199c.521-.521 1.365-.521 1.886 0z",
    fill: "#51c466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.477 210.064.182-3.208-2.693 1.766-.966-1.679 2.875-1.441-2.875-1.442.966-1.679 2.693 1.766-.182-3.207h1.924l-.174 3.207 2.693-1.766.966 1.679-2.883 1.442 2.883 1.441-.966 1.679-2.693-1.766.174 3.208z",
    fill: "#a9a6ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingAccess);
export default __webpack_public_path__ + "static/media/pricing_access.78effd6f518173f52e9ff89175887b3d.svg";
export { ForwardRef as ReactComponent };